const styles = {
    root: {
        display: 'flex',
        flexDirection: 'row',
    },
    autoComplete: {
        '.MuiOutlinedInput-root': {
            borderRadius: '16px',
            width: '400px',
        },
    },
};

export default styles;
